<template>
    <el-dialog title="同步商品" :visible.sync="show" custom-class="no-pm-dialog dz-dialog-header" width="475px">
        <div class="syn-dialog">
            <div>上次同步时间：{{ synTime }}</div>
            <el-radio-group v-model="type" class="pb20">
                <el-radio :label="0">增量同步商品</el-radio>
                <el-radio :label="1">全量同步商品</el-radio>
                <el-radio :label="2">同步指定商品</el-radio>
            </el-radio-group>
            <p v-if="type == 0">同步商品需较长时间，软件退出不影响同步</p>
            <p v-if="type == 0" class="mt10 mb10" style="color: #f59a23">
                全量同步商品时，系统先将本地商品清空后再进行全量同步
            </p>
            <p v-else-if="type == 1">同步全部商品需较长时间，软件退出不影响同步</p>
            <el-input
                v-else
                v-model="textarea"
                type="textarea"
                placeholder="填写同步商品ID，多个商品以','隔开。"
                :rows="6"
            />
            <div class="dz-flex">
                <el-button type="primary" :loading="synLoading" @click="syn">开始同步</el-button>
                <el-button @click="show = false">取消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['synTime'],
    data() {
        return {
            show: false,
            type: 0,
            productIds: [],
            textarea: '',
            synLoading: false,
        };
    },
    methods: {
        open() {
            this.type = 0;
            this.textarea = '';
            this.productIds = [];
            this.show = true;
        },
        syn() {
            if (this.type == 2) {
                if (!this.textarea) {
                    this.$message.warning('请填写同步商品ID');
                    return;
                }
            }
            this.synLoading = true;
            this.productIds = this.textarea.split(',');
            this.$ajax
                .post('/api/tiktok/product/SyncProductsTaskV2', {
                    syncType: this.type,
                    productIds: this.type == 0 || this.type == 1 ? [] : this.productIds,
                })
                .then((res) => {
                    this.synLoading = false;
                    if (res.code === 200) {
                        this.show = false;
                        if (res.result === '同步已完成') {
                            return;
                        }
                        this.$message({
                            message: '开始同步',
                            type: 'success',
                        });
                        // this.synLoading = false;
                        this.$emit('syn', res.result);
                    }
                })
                .catch(() => {
                    this.synLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog .el-dialog--scroll {
    max-height: unset;
}
.syn-dialog {
    line-height: 1;
    padding: 10px 23px 23px 23px;

    > div {
        &:nth-child(1) {
            color: #333;
            margin-bottom: 30px;
        }
    }

    .dz-flexalign-center {
        margin-bottom: 30px;
    }

    p {
        font-size: 12px;
        color: #999;
    }

    .dz-flex {
        margin-top: 20px;

        > div {
            width: 100px;
            line-height: 36px;
            margin-right: 10px;
        }
    }
}
</style>
